import { confirm } from 'best-modules/plugins'
import { Module } from 'vuex'
import { loginFirst, loginSecond, logout } from '@/requests/auth'

export interface Credentials {
  email: string
  password: string
}

const state = {
  qrCode: localStorage.getItem('qrCode') || null,
  token: localStorage.getItem('token') || null,
  authUser: {
    id: localStorage.getItem('userId') || null,
    name: localStorage.getItem('userName') || null,
  },
}

const auth: Module<typeof state, any> = {
  state() {
    return state
  },
  mutations: {
    setQrCode(state, qrCode) {
      state.qrCode = qrCode
      localStorage.setItem('qrCode', qrCode)
    },
    removeQrCode(state) {
      state.qrCode = null
      localStorage.removeItem('qrCode')
    },
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    removeToken(state) {
      state.token = null
      localStorage.removeItem('token')
    },
    setAuthUser(state, authUser: { id: number; name: string }) {
      Object.assign(state.authUser, authUser)
      localStorage.setItem('userId', String(authUser.id))
      localStorage.setItem('userName', authUser.name)
    },
    removeAuthUser(state) {
      state.authUser.id = null
      state.authUser.name = null
      localStorage.removeItem('userId')
      localStorage.removeItem('userName')
    },
  },
  actions: {
    loginFirst({ commit }, credentials: { email: string; password: string }) {
      return loginFirst(credentials).then(res => {
        commit('setAuthUser', res.user)
        if (res.url) {
          commit('setQrCode', res.url)
        }
      })
    },
    loginSecond({ commit, state }, code) {
      if (typeof state.authUser.id === 'number') {
        return loginSecond(state.authUser.id, code).then(res => {
          commit('setToken', res.token)
          commit('removeQrCode')
        })
      }
    },
    logout({ commit }) {
      return confirm({ text: 'Ви дійсно бажаєте завершити сесію? ' }).then(
        () => {
          return logout().then(() => {
            commit('removeToken')
            commit('removeQrCode')
            commit('removeAuthUser')
          })
        }
      )
    },
  },
}

export { auth }
